import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchPack, getCode, clearCode, errMsg } from "@/lib/api";

export const usePack = () => {
  const [pack, setPack] = useState(null);
  const nav = useNavigate();
  useEffect(() => {
    const code = getCode();
    if (!code) return nav("/acceder");
    fetchPack(code).then(setPack).catch((e) => { clearCode(); nav("/acceder", { state: { error: errMsg(e) } }); });
  }, [nav]);
  return [pack, setPack];
};
